module.exports = __webpack_public_path__ + "img/female_resultA.fcf80c94.png";